// Search parameters of the specs routes: unknown or malformed values are dropped, not fatal.

import { isKindSlug, State } from "@cosmosai/api-client";
import { z } from "zod";
import type { SpecSearch, SpecsSearch } from "../context";

const text = z.string().trim().min(1).max(200).optional().catch(undefined);
const version = z.coerce.number().int().min(1).optional().catch(undefined);

const SpecsSearchSchema = z.object({
  kind: z.string().refine(isKindSlug).optional().catch(undefined),
  project: text,
  state: State.optional().catch(undefined),
  q: text,
});

const SpecSearchSchema = z.object({
  // A built-in tab or one registered for the kind (kinds/tabs.ts); the page falls back otherwise.
  tab: z
    .string()
    .regex(/^[a-z][a-z-]{0,30}$/)
    .optional()
    .catch(undefined),
  v: version,
  compare: version,
});

/** Keeps only the fields that are set, so URLs stay short. */
const defined = <T extends object>(value: object): T =>
  Object.fromEntries(Object.entries(value).filter(([, v]) => v !== undefined)) as T;

export const validateSpecsSearch = (raw: Record<string, unknown>): SpecsSearch =>
  defined<SpecsSearch>(SpecsSearchSchema.parse(raw));

export const validateSpecSearch = (raw: Record<string, unknown>): SpecSearch =>
  defined<SpecSearch>(SpecSearchSchema.parse(raw));
